import { createStore } from 'vuex'

export default createStore({
  state: {
    userInfo:{},
    isOpen:false,
    index:localStorage.getItem("index")|| 0,
    dictMap:[],
    regionMap:[],
    user:{},
    qiNiuToken:localStorage.getItem("qiNiuToken"),
    vm:{},
    noticeCount:0,
    cropUser:null,//企业用户
  },
  mutations: {
    addIndex(state,index){
      state.index = index;
    },
    addDict(state, dict) {
      state.dictMap = dict
    },
    addUser(state,user){
      state.user = user;
    },
    addRegion(state,regionMap){
      state.regionMap = regionMap;
    },
    addQiNiuToken(state,qiNiuToken){
      state.qiNiuToken = qiNiuToken;
    },
    addPageVueObject(state,value){
      state.vm = value;
    },
    addNoticeCount(state,noticeCount){
      state.noticeCount = noticeCount;
    },
    addCropUser(state,user){
      state.cropUser = user;
    }
  },
  modules: {
  }
})
